import { SIZE } from '../../../constants/size'
import Modal, { Box, Header } from '../../Modal'
import { RadioGroupModalForm } from '../RadioGroupModalForm'

function RadioGroupModal({
  formFieldsProps,
  initialValues,
  modalSize = SIZE.MEDIUM,
  qaName,
  title,
  onCancel,
  onClose,
  onSubmit,
}) {
  function handleSubmit(values) {
    onSubmit?.(values)
  }

  return (
    <Modal qaName={qaName}>
      <Box size={modalSize}>
        <Header text={title} onClose={onClose} />
        <RadioGroupModalForm
          formFieldsProps={formFieldsProps}
          initialValues={initialValues}
          onCancel={onCancel || onClose}
          onSubmit={handleSubmit}
        />
      </Box>
    </Modal>
  )
}

export default RadioGroupModal
